var _rect, _path, _rect2, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZezamiiAccessMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#001F97"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3064 11.9999H16.3506M10.293 8.86442L10.2997 8.08948M8.9825 5.33325H11.4572C12.1936 5.33325 12.7905 5.93021 12.7905 6.66659V10.1141V13.9485V17.3333C12.7905 18.0696 12.1936 18.6666 11.4572 18.6666H8.9825C8.24612 18.6666 7.64917 18.0696 7.64917 17.3333V6.66659C7.64917 5.93021 8.24612 5.33325 8.9825 5.33325Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.6926,
    y: 4.66284,
    width: 4.72261,
    height: 5.09349,
    rx: 1,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.886 8.66284V8.27953L17.4103 6.14075H15.883V5.6083H18.2217V5.99161L16.6959 8.13038H18.2247V8.66284H15.886Z",
    fill: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZezamiiAccessMarker);
export default __webpack_public_path__ + "static/media/ZezamiiAccessMarker.b0d29649e9b9a5f54514fe673545098c.svg";
export { ForwardRef as ReactComponent };